import React, { useEffect, useMemo, useState } from 'react';
import {  Container } from 'reactstrap';
import OutletSettingDetails from './components/OutletSettingDetails';

import OutletSettingDetailsModal from '../AddOrUpdate/components/OutletSettingDetailsModal';


const OutletSettingDetailsIndex = () => {
  useEffect(() => {
    getAllRoles();
  }, [])

  const [reactTableData, setReactTableData] = useState([]);

  const [temp, setTempData] = useState("");

  const [viewDetailPopup, setViewDetailPopup] = useState(false);

  const [isTitle, setTitle] = useState(null);

  const getAllRoles = async () => {
    // const response = await umsApis.roleApi.findAllRoles();
    // if (response.status === 200) {
    // setReactTableDataRoles({ tableHeaderData: columns, tableRowsData: response.data.data });
    //setReactTableDataRoles({ tableHeaderData: columns, tableRowsData: null }); 
    setReactTableData({ tableHeaderData: columns, tableRowsData: null });
    // }
  };



  const columns = useMemo(
    () => [
      {
        Header: '#',
        accessor: (row, i) => i + 1, // Or just use Cell below for more control
        disableGlobalFilter: true,
        disableSortBy: true,
        width: 65,
        Cell: ({ row }) => row.index + 1, // <-- This sets the serial number based on row index
      },
      {
        Header: 'ETA Threshold per Min',
        accessor: 'emiratesName',
        disableGlobalFilter: false,
      },
      {
        Header: 'Trip Status',
        accessor: 'firstName',
        disableGlobalFilter: false,
      },
      {
        Header: 'Rider Pass Code',
        accessor: 'lastName',
        disableGlobalFilter: false,
      },
      {
        Header: 'Unloading Time ',
        accessor: 'role',
        disableGlobalFilter: false,
      },
      {
        Header: 'Delivery Time ',
        accessor: 'deliverytime',
        disableGlobalFilter: false,
      },
  

      {
        Header: 'Action',
        accessor: 'edit',
        Cell: row => (
          <div className="icon-style" >
            {/* <BlueOnGreenTooltip title="Edit Hub Setting Details">
              <img
                src={editIcon}
                onClick={() => edit(row.row.original)}
                style={{ width: "25px", margin: "3px", cursor: "pointer" }}
                alt="edit"
              />
            </BlueOnGreenTooltip> */}
          </div>
        ),
      },
    ],
    [],
  );

  const edit = async (event) => {
    //if (event.custId) {
    setTempData(event);
    setViewDetailPopup(true);
    setTitle("Edit - Outlet Settings Details")
    // const response = await umsApis.userApi.findUserById(event.custId);
    // if (response.status === 200) {
    //   setUserDataById(response.data.data);
    // }
    // }
  }


  return (
    <Container>
      {/* {(isAuthenticated && isAuthenticated === USER_ROLE && reactTableDataRoles && reactTableDataRoles != null && reactTableDataRoles.tableRowsData != null) &&
        <RegistrationModal reactTableDataRoles={reactTableDataRoles} />
      } */}

      {/* {(reactTableData && reactTableData != null && reactTableData.tableRowsData != null) && */}
      <OutletSettingDetails reactTableData={reactTableData} />

      {viewDetailPopup &&
        <OutletSettingDetailsModal
          modalShow={viewDetailPopup}
          setModalShow={setViewDetailPopup}
          userData={temp}
          isTitle={isTitle} 
        />}
    </Container>
  );
};

export default OutletSettingDetailsIndex;